import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxTransferEdit = cashBoxRegister("CashBoxTransferEdit")

export default CashBoxTransferEdit
